<template>

  <router-link v-if="notificationsOverview" :to="'/notifications'">
    <div class="notification-sink u-ml3 u-mt2 u-mb3" :class="additionalClass">
      <div class="notification-sink__icon u-pl2">
        <icon :scale="1" name="bell"></icon>

      </div>

      <div class="notification-sink__messages">
        <div class="notification-sink__critical" v-if="notificationsOverview.criticals > 0">{{notificationsOverview.criticals}} Critical</div>
        <div class="notification-sink__warning" v-if="notificationsOverview.warnings > 0">{{notificationsOverview.warnings}} Warnings</div>
        <div class="notification-sink__ok" v-if="notificationsOverview.warnings === 0 && notificationsOverview.criticals === 0">System is healthy</div>
      </div>

    </div>
  </router-link>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {

    computed: {
      ...mapState('shared', ['notificationsOverview']),
      additionalClass () {
        if (this.notificationsOverview) {
          if (this.notificationsOverview.criticals > 0 || this.notificationsOverview.warnings > 0) {
            return 'notification-sink--danger'
          }
        }
        return 'notification-sink--ok'
      }

    },
    methods: {
      ...mapActions('shared', ['loadNotificationsOverview'])
    },
    created () {
      console.log('created - notifications')
      this.loadNotificationsOverview()
    },
    name: 'notification-widget'
  }
</script>

<style scoped>
  .notification-sink {
    display: flex;
    height: 3em;
    border-radius: 4px;
  }

  .notification-sink--ok {
    background-color: #2cb000;
    height: 2em;
  }

  .notification-sink--danger {
    background-color: #6f1006;
  }

  .notification-sink__messages {
    text-align: center;
    align-self: center;
    width: 100%;
    color: #fff;
  }

  .notification-sink__icon {
    text-align: center;
    line-height: 3em;
    color: #ea0c0c;
  }
  .notification-sink--ok .notification-sink__icon {
    display: none;
  }



</style>